// extracted by mini-css-extract-plugin
export default {"resetWrapper":"auth__resetWrapper__AMJbfz","belowHeaderText":"auth__belowHeaderText__VMrCUO","paddedRow":"auth__paddedRow__x70E_j","field":"auth__field__xtnqDG"};